interface IconProps {
  className?: string;
}

export function HamburgerIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  );
}
